import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=50058f91&scoped=true&"
import script from "./CancelButton.vue?vue&type=script&lang=ts&"
export * from "./CancelButton.vue?vue&type=script&lang=ts&"
import style0 from "./CancelButton.vue?vue&type=style&index=0&id=50058f91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50058f91",
  null
  
)

export default component.exports